import { render, staticRenderFns } from "./budget-header-test.vue?vue&type=template&id=0e3d719d&"
import script from "./budget-header-test.vue?vue&type=script&lang=ts&"
export * from "./budget-header-test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports